<template>
  <div>
    <div class="p-4 mx-auto my-4 bg-kas-100 w-96">
      <label for="hakukentta" class="block mb-2 font-bold">Tästä löydät yhteyshenkilön tiedot. Kirjoita ensin osoite, kaupunki tai postinumero.</label>
      <input id="hakukentta" class="w-full p-4 text-lg bg-white" placeholder="Etsi" v-model="s" />
    </div>

    <div v-if="buildings && buildings.length">
      <div v-for="building in buildings" :key="building.id" class="p-4 mb-8 bg-kas-100">
        <h1 class="text-2xl font-bold text-kas-500">{{ building.street_address }}</h1>

        <div class="grid grid-cols-1 gap-8 md:grid-cols-2">
          <div v-for="(people, type) in building.people" :key="type">
            <h2 class="text-lg font-bold">{{ type }}</h2>
            <div v-for="person in people" :key="person.id">
              <p class="font-bold">{{ person.name }}</p>
              <p v-if="person.phone_number">{{ person.phone_number }}</p>
              <p v-if="person.email_address">{{ person.email_address }}</p>
            </div>
          </div>
          <div>
            <h2 class="text-lg font-bold">Vuokravalvonta</h2>
            <div>
              <p>maksuihin liittyvät asiat</p>
              <p>010 2872 630 puhelinaika ma-pe klo 9-12</p>
              <p>vuokravalvonta@kas.fi</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useBuildingsPeople from '../use/buildings-people';

export default {
  name: 'BuildingsPeopleFinder',
  setup() {
    const { s, buildings } = useBuildingsPeople()

    return {
      s, buildings,
    }
  }
}
</script>
